module.exports = __webpack_public_path__ + "img/gasnatural.f00fb563.svg";